import Status from './Status';
import Mail from './Mail';

export default {
  Status,
  Mail,
};
